import React from 'react';
import langConf from "../js/lang";

const Video = ({language}) => {
    return (
        <div className="col-xl-12 col-12">
            <iframe width="320" height="320" title="videoGuide" src={`${langConf[language].videoURL}?controls=0&amp;autoplay=1&amp;mute=1&amp;loop=1&amp;start=4`} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        </div>
    );
};

export default Video;